"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  height: 22px;\n  width: 10px;\n  border-left: 1px solid #342b3f;\n  padding-left: 3px;\n\n  img {\n    width: 7px;\n    vertical-align: middle;\n  }\n\n  &.active {\n    img {\n      transform: rotate(180deg);\n    }\n  }\n"])));

exports.Container = Container;